import { QueryKey } from '@/configs/queryKeys';
import { Attachment, Translations, UUID } from '@/types/types';
import { ComponentCategory } from './ComponentCategoryApi';
import { AttributeValue } from './AttributeValueApi';
import EntityApi, { EntityBase } from './EntityApi';

export interface Asset extends EntityBase {
	name: string;
	attachment?: Attachment;
	options?: {
		color: string;
		emissive: string;
		roughness: number;
		metalness: number;
		opacity: number;
		userData: string;
	};
}

export interface Component extends EntityBase {
	name: string;
	componentIndex: string;
	render?: Attachment;
	asset?: Asset;
	price: number;
	componentCategory: ComponentCategory;
	attributeValues: AttributeValue[];
	translations: Translations<{
		name: string;
	}>;
}

class ComponentApi extends EntityApi<Component> {
	constructor() {
		super(QueryKey.components);
	}
}

export default new ComponentApi();
